/* eslint-disable */
import React from 'react';
import Option from './Option';
import Helpers from '../helpers';

import { ProductFormContext } from '../../../context/product-form-context';

export default function OptionGroupAsCombined({
		option,
		index:group_index,
		setFilter,
		setFilters,
		filters,
	}){
	//	--------
	//	Mount detection: detect when this component is mounted so processes do not continue.
	//	--------
	const mounted = React.useRef(false);
	React.useEffect(() => {
		//	Gets set to true on component mount.
		mounted.current = true;
		//	Gets set to false on component unmount by React.
		return () => { mounted.current = false; };
	}, []);

	const {
		availabilityMap,
		product,
		showErrors,
		variant
	} = React.useContext(ProductFormContext);

	const all_option_values  =	option.values;

	const available_option_values = Helpers.getAvailableOptionsWithinSelections(
		product,
		group_index,
		filters,
		availabilityMap,
	);

	//	----------
	//	Pre-select OptionGroups containing only one 'available' option (which is based on 'filters' have already been applied)
	//	----------
	React.useEffect(() => {
		const this_option_group_already_has_a_filter = !!filters[group_index];
		if( mounted.current && !this_option_group_already_has_a_filter && available_option_values.length ){
			// console.log('one',group_index,available_option_values[0]);	//	Debugging Only
			setFilter(group_index,available_option_values[0]);
		}
	},[mounted.current, filters, group_index]);

	React.useEffect(() => {
		// console.log('variant', variant); // Debug
		// console.log('options', options); // Debug
		// console.log('available_option_values', available_option_values); // Debug
		// console.log('filters[group_index]', filters[group_index]); // Debug

		if (available_option_values.indexOf(filters[group_index]) !== -1) {
			return;
		}

		if (!available_option_values.length) {
			// This if prevents an infinitew loop when a direct link is used.
			// The variant can become null if a product option has no stock for
			// any of it's variants
			if (variant !== null && variant?.selectedOptions[group_index].value !== options[0]?.value) {
				// THis allows the user to select oos products
				setFilter(group_index, variant?.selectedOptions[group_index].value);
			} else if (options[0] === null) {
				// This condition happens when all products are oos and the user switches between parent
				// product options
				const defaultOption = options.find(_option => { return ![null, undefined].includes(_option); });
				setFilter(group_index, defaultOption.value);
			} else {
				// This set the first available option when switching parent values.
				setFilter(group_index, options[0]?.value);
			}
		}

		if (available_option_values.length) {
			if (variant === null) {
				// This sets the first available variant when switching parents
				setFilter(group_index, available_option_values[0]);
			} else {
				setFilter(group_index, filters[group_index]);
			}
		}

	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [variant]);

	//	---------------
	//	Render Children
	//	---------------
	const options = all_option_values.map((_v,_i)=>{
		const selected = filters[group_index]==_v;
		const doesExist = Helpers.doesOptionExistWithinSelections(
			product,
			group_index,
			_v,
			filters,
		);
		const isInStock = Helpers.isOptionInStockWithinSelections(
			product,
			group_index,
			_v,
			filters,
			availabilityMap,
		);

		if (!doesExist) return null;

		return <Option
			group_index={group_index}
			key={_v}
			value={_v}
			selected={selected}
			setFilter={setFilter}
			setFilters={setFilters}
		/>
	})
	.filter(_o=>!!_o);	//	Clean null values from array so .length is accurate

	//	Don't render anything if there are no options within this Option Group.
	if (!options.length)	return null;

	const selectedLabel	= filters[group_index];

	const classNames = [
		'pdp-form__option-group',
		!selectedLabel && showErrors ? 'error' : null,
	].join(' ');

	return (
	<div
		className={classNames}
		data-index={group_index}
		data-name={option.name.trim()}
		data-handle={option.name.trim().toLowerCase()}
	>
		{/* <div className={`pdp-form__option-group-label`}>
			<span className={'name'}>{`${ option.name }: `}</span>
			<span className={'selected'}>{selectedLabel}</span>
		</div> */}
		<div className={`pdp-form__options pdp-form__options-buttons`}>
			{options}
		</div>
		{!selectedLabel && showErrors && (
			<div className={`pdp-form__option-group-error`}>
				{`Please select a ${option.name.toLowerCase()}`}
			</div>
		)}
	</div>
	);

}//function
